/**
 * KT Load More — Fetches the next collection page and appends products to the grid.
 * Uses event delegation so it survives DOM replacements from facets/filters.
 * Fetches the full next page (no section_id) so Shopify's paginate tag works correctly.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.kt-load-more__btn');
    if (!button) return;

    var pageSize = parseInt(button.getAttribute('data-page-size'), 10);
    var totalItems = parseInt(button.getAttribute('data-total-items'), 10);
    var currentPage = parseInt(button.getAttribute('data-current-page') || '1', 10);
    var nextPage = currentPage + 1;

    if (button.classList.contains('kt-load-more__btn--loading')) return;

    button.classList.add('kt-load-more__btn--loading');
    button.setAttribute('aria-busy', 'true');

    /*
     * Build a clean URL from the current browser URL.
     * facets.js keeps window.location in sync via pushState, so filters/sort
     * are always reflected here. We only add the page number.
     * NO section_id — we fetch the full page so paginate works correctly.
     */
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    url.searchParams.set('page', String(nextPage));
    var fetchUrl = url.pathname + '?' + url.searchParams.toString();

    fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('[KT Load More] Network error: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        /* ── Locate grids ── */
        var newGrid = doc.querySelector('#product-grid');
        var currentGrid = document.querySelector('#product-grid');

        if (!newGrid || !currentGrid) {
          console.warn('[KT Load More] Could not find #product-grid in response');
          return;
        }

        var newItems = Array.from(newGrid.querySelectorAll(':scope > li'));
        if (newItems.length === 0) {
          console.warn('[KT Load More] No new items found on page ' + nextPage);
          button.style.display = 'none';
          return;
        }

        var firstNew = newItems[0];

        /* ── Update page counter FIRST (before anything that could throw) ── */
        button.setAttribute('data-current-page', String(nextPage));

        /* ── Append new product cards ── */
        newItems.forEach(function (li) {
          currentGrid.appendChild(li);
        });

        /* Re-trigger Shopify scroll-reveal animations safely */
        try {
          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(document.documentElement);
          }
        } catch (e) { /* animations are non-critical */ }

        /* Accessibility: move focus to first new product */
        if (firstNew) {
          firstNew.setAttribute('tabindex', '-1');
          firstNew.focus({ preventScroll: true });
        }

        /* ── Update counter text ── */
        var wrapper = button.closest('.kt-load-more-wrapper');
        if (wrapper) {
          var countSpan = wrapper.querySelector('[data-current-count]');
          if (countSpan) {
            var newCount = parseInt(countSpan.textContent, 10) + newItems.length;
            if (newCount > totalItems) newCount = totalItems;
            countSpan.textContent = String(newCount);
          }
        }

        /* ── Determine if more pages exist ── */
        var responseBtn = doc.querySelector('.kt-load-more__btn');

        if (!responseBtn) {
          /* The fetched page has no "load more" button → last page reached */
          button.style.display = 'none';
        } else {
          /* Sync total in case filters changed the product count */
          var newTotal = responseBtn.getAttribute('data-total-items');
          if (newTotal) {
            button.setAttribute('data-total-items', newTotal);
            totalItems = parseInt(newTotal, 10);
            if (wrapper) {
              var totalSpan = wrapper.querySelector('.kt-load-more__total');
              if (totalSpan) totalSpan.textContent = newTotal;
            }
          }
        }
      })
      .catch(function (error) {
        console.error('[KT Load More]', error);
      })
      .finally(function () {
        button.classList.remove('kt-load-more__btn--loading');
        button.removeAttribute('aria-busy');
      });
  });
})();
